import {createSelector} from 'reselect';
import {RootState} from 'typesafe-actions';
import {ESingleState} from './reducer';
import {ISinglePlate, ISingleVoting} from './types';
import IInfo = MyTypes.IInfo;

export const eSingleSelector = (state: RootState): ESingleState =>
  state.eSingle;

export const getESingleInfo = createSelector<any, any, IInfo>(
  eSingleSelector,
  (state: ESingleState) => state.info
);

// SINGLE VOTE SELECTORS
export const getESinglePlates = createSelector<any, any, ISinglePlate[]>(
  eSingleSelector,
  (state: ESingleState) => state.plates || []
);

// SINGLE VOTE SELECTORS
export const getESingleVoteResult = createSelector<
  any,
  any,
  ISingleVoting[] | []
>(eSingleSelector, (state: ESingleState) => state.vote || []);



// WEBPACK FOOTER //
// ./src/features/election-single/store/selectors.ts